import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-delegasi-split-modal',
  templateUrl: './delegasi-split-modal.component.html',
  styleUrls: ['./delegasi-split-modal.component.css'],
})
export class DelegasiSplitModalComponent implements OnInit {
  kw: any;
  load = false;
  loadRegu = false;
  hasilX: any = {};
  kelompok: any = '';
  nama: any = '';
  billingDay: any = '';
  branchId = '';
  group = '';
  regu = '';
  surveyorId = '';
  loadKelompok = false;
  kelompokOptions: Array<{ id: string; text: string; surveyor_name: string }> = [];
  showFormKonfigurasi = false;
  showFormTambahRegu = false;
  nextReguSeq = 1;
  nextReguName = 'Regu 1';
  tambahReguLeader = '';
  billingDayOptions = ['SENIN', 'SELASA', 'RABU', 'KAMIS', 'JUMAT', 'SABTU', 'MINGGU'];
  reguOptions: Array<{ id: string; text: string; seq: number }> = [];
  anggotaOptions: Array<{ id: string; text: string }> = [];
  openRegional = false;
  loadRegional = false;
  searchRegional = '';
  subdistrictsLabel = '';
  regionalOptions: any[] = [];
  private regionalSearchTimer: any;
  newKelompok: any = {
    nama: '',
    biling_day: '',
    sales_id: '',
    alamat: '',
    subdistricts_id: '',
    rt: '',
    rw: '',
    is_groups_leader: '',
    is_teams_leader: '',
  };

  constructor(
    public navParams: NavParams,
    public api: ApiService,
    public util: UtilService,
  ) {
    try {
      const ls = JSON.parse(localStorage.getItem('user') || '{}');
      this.branchId = ls?.branch_id || '';
      this.kw = JSON.parse(this.navParams.data.id);
    } catch (error) {
      this.util.showToast('Data Lead_id tidak terparsing', 'danger', 'bottom');
      this.kw = [];
    }

    this.kelompok = this.navParams.data.kelompok || '';
    this.nama = this.navParams.data.nama || '';
    this.billingDay = this.navParams.data.biling_day || '';
    this.initDefaults();
    this.loadKelompokOptions();
  }

  ngOnInit(): void {}

  get hasSelectedGroup(): boolean {
    return !!String(this.group || '').trim();
  }

  private loadKelompokOptions() {
    this.loadKelompok = true;
    this.api.get('data/master/kelompok/' + this.branchId + '/' + this.billingDay).subscribe(
      (data: any) => {
        this.loadKelompok = false;
        if (data?.error == 0) {
          const list = Array.isArray(data?.data) ? data.data : [];
          this.kelompokOptions = list
            .map((item: any) => ({
              id: String(item.id || ''),
              text: String(item.text || item.name || item.id || ''),
              surveyor_name: String(item.surveyor_name || ''),
            }))
            .filter((item) => !!item.id);
        } else {
          this.kelompokOptions = [];
          if (data?.message) {
            this.util.showToast(data.message, 'danger', 'bottom');
          }
        }
      },
      (error) => {
        this.loadKelompok = false;
        this.kelompokOptions = [];
        this.api.errorCond(error);
      }
    );
  }

  onGroupChange(groupId: string) {
    this.group = groupId || '';
    this.regu = '';
    this.showFormTambahRegu = false;
    this.surveyorId = '';

    if (!groupId) {
      this.reguOptions = [];
      return;
    }

    const selected = this.kelompokOptions.find((item) => item.id === groupId);
    this.surveyorId = selected?.surveyor_name || '';
    this.loadReguByGroup(groupId);
  }

  openFormKonfigurasi() {
    this.showFormKonfigurasi = true;
    this.showFormTambahRegu = false;
    this.group = '';
    this.regu = '';
    this.surveyorId = '';
    this.reguOptions = [];
    this.initDefaults();
    this.toggleModalExpanded(true);
  }

  closeFormKonfigurasi() {
    this.showFormKonfigurasi = false;
    this.resetNewKelompokForm();
    this.toggleModalExpanded(false);
  }

  openFormTambahRegu() {
    if (!this.hasSelectedGroup) {
      this.util.showToast('Pilih Nama Kelompok Baru terlebih dahulu', 'danger', 'bottom');
      return;
    }

    this.showFormTambahRegu = true;
    this.regu = '';
    this.tambahReguLeader = '';
    this.computeNextRegu();

    if (this.anggotaOptions.length === 1) {
      this.tambahReguLeader = this.anggotaOptions[0].id;
    }

    // Refresh list regu existing untuk hitung seq terbaru
    this.loadReguByGroup(this.group, true);
  }

  closeFormTambahRegu() {
    this.showFormTambahRegu = false;
    this.group = '';
    this.regu = '';
    this.reguOptions = [];
    this.tambahReguLeader = '';
    this.nextReguSeq = 1;
    this.nextReguName = 'Regu 1';
    this.surveyorId = '';
  }

  private computeNextRegu() {
    const maxSeq = (this.reguOptions || []).reduce((max, item) => {
      const seq = Number(item?.seq);
      return Number.isFinite(seq) && seq > max ? seq : max;
    }, 0);
    this.nextReguSeq = maxSeq + 1;
    this.nextReguName = `Regu ${this.nextReguSeq}`;
  }

  private toggleModalExpanded(expanded: boolean) {
    const modalEl = document.querySelector(
      'ion-modal.wd-assignXX, ion-modal.wd-assignXX-expanded'
    );
    if (!modalEl) {
      return;
    }
    if (expanded) {
      modalEl.classList.add('wd-assignXX-expanded');
    } else {
      modalEl.classList.remove('wd-assignXX-expanded');
    }
  }

  private getLeadIds(): string[] {
    if (Array.isArray(this.kw)) {
      return this.kw.map((item) => String(item)).filter(Boolean);
    }
    if (this.kw !== undefined && this.kw !== null && this.kw !== '') {
      return [String(this.kw)];
    }
    return [];
  }

  private initDefaults() {
    const source = this.navParams.data || {};
    this.newKelompok.biling_day = source.biling_day || '';
    this.newKelompok.sales_id = source.sales_id || '';
    this.newKelompok.alamat = source.alamat || '';
    this.newKelompok.subdistricts_id = source.subdistricts_id || '';
    this.subdistrictsLabel = source.subdistricts_name || '';
    this.newKelompok.rt = source.rt || '';
    this.newKelompok.rw = source.rw || '';

    const members = Array.isArray(source.anggota) ? source.anggota : [];
    this.anggotaOptions = members
      .map((item: any) => ({
        id: String(item.lead_id || ''),
        text: `${item.lead_name || '-'} (${item.lead_id || '-'})`,
      }))
      .filter((item: any) => !!item.id);

    if (!this.newKelompok.is_groups_leader && this.anggotaOptions.length === 1) {
      this.newKelompok.is_groups_leader = this.anggotaOptions[0].id;
    }
    if (!this.newKelompok.is_teams_leader && this.anggotaOptions.length === 1) {
      this.newKelompok.is_teams_leader = this.anggotaOptions[0].id;
    }
  }

  private resetNewKelompokForm() {
    this.newKelompok = {
      nama: '',
      biling_day: this.newKelompok.biling_day || '',
      sales_id: this.newKelompok.sales_id || '',
      alamat: '',
      subdistricts_id: this.newKelompok.subdistricts_id || '',
      rt: '',
      rw: '',
      is_groups_leader: '',
      is_teams_leader: '',
    };
  }

  openRegionalPicker() {
    this.openRegional = true;
    this.searchRegional = '';
    this.regionalOptions = [];
  }

  closeRegionalPicker() {
    this.openRegional = false;
    this.searchRegional = '';
  }

  clearRegionalSearch() {
    this.searchRegional = '';
    this.regionalOptions = [];
  }

  searchRegionalData() {
    if (this.regionalSearchTimer) {
      clearTimeout(this.regionalSearchTimer);
    }
    this.regionalSearchTimer = setTimeout(() => {
      const keyword = String(this.searchRegional || '').trim();
      if (!keyword) {
        this.regionalOptions = [];
        return;
      }
      this.fetchRegional(keyword);
    }, 350);
  }

  private fetchRegional(keyword: string) {
    this.loadRegional = true;
    const param = {
      q: keyword || '',
      page: '1',
      limit: '50',
      xsort: 'kab_name',
      xorder: 'desc',
    };
    this.api.post('data/regional', param).subscribe(
      (data: any) => {
        this.loadRegional = false;
        if (data?.error == 0) {
          this.regionalOptions = data?.data?.rows || [];
        } else {
          this.regionalOptions = [];
          if (data?.message) {
            this.util.showToast(data.message, 'danger', 'bottom');
          }
        }
      },
      (error) => {
        this.loadRegional = false;
        this.regionalOptions = [];
        this.api.errorCond(error);
      }
    );
  }

  selectRegional(item: any) {
    this.newKelompok.subdistricts_id = item?.desa_id || '';
    this.subdistrictsLabel = item?.desa_name || '-';
    if (item?.kec_name || item?.kab_name) {
      this.subdistrictsLabel = [
        item?.desa_name,
        item?.kec_name,
        item?.kab_name,
      ]
        .filter(Boolean)
        .join(', ');
    }
    this.openRegional = false;
    this.searchRegional = '';
    this.regionalOptions = [];
  }

  private loadReguByGroup(groupId: string, forTambahRegu = false) {
    this.loadRegu = true;
    if (!forTambahRegu) {
      this.regu = '';
    }
    this.reguOptions = [];

    this.api.get('data/master/regu/' + groupId).subscribe(
      (data: any) => {
        this.loadRegu = false;
        if (data?.error == 0) {
          const list = Array.isArray(data?.data) ? data.data : [];
          this.reguOptions = list
            .map((item: any, index: number) => {
              const seq = Number(item.seq);
              const resolvedSeq = Number.isFinite(seq) ? seq : index + 1;
              return {
                id: String(item.id || ''),
                text: String(item.text || item.id || `Regu ${resolvedSeq}`),
                seq: resolvedSeq,
              };
            })
            .filter((item) => !!item.id);

          if (forTambahRegu || this.showFormTambahRegu) {
            this.computeNextRegu();
          }
        } else {
          this.reguOptions = [];
          if (forTambahRegu || this.showFormTambahRegu) {
            this.computeNextRegu();
          }
          if (data?.message) {
            this.util.showToast(data.message, 'danger', 'bottom');
          }
        }
      },
      (error) => {
        this.loadRegu = false;
        this.reguOptions = [];
        if (forTambahRegu || this.showFormTambahRegu) {
          this.computeNextRegu();
        }
        this.api.errorCond(error);
      }
    );
  }

  private getSurveyorId(): string {
    return String(this.surveyorId || '').trim();
  }

  private validateFormKonfigurasi(): boolean {
    return true;
  }

  handleSelection(selectedValue: string, model: string) {
    if (model === 'sales') {
      this.newKelompok.sales_id = selectedValue;
    }
  }

  private submitRequest(param: any) {
    this.load = true;
    this.api.put('backoffice/delegasi/pindah-kelompok', param).subscribe(
      (data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message, 'success', 'bottom');
        this.api.dismissData('', 'confirm');
      },
      (error) => {
        this.load = false;
        this.api.errorCond(error);
      }
    );
  }

  private submitReguRequest(method: 'put' | 'post', url: string, body: any) {
    this.load = true;
    const request$ =
      method === 'put' ? this.api.put(url, body) : this.api.post(url, body);

    request$.subscribe(
      (data: any) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(
          this.hasilX?.message || 'Berhasil',
          this.hasilX?.error == 0 ? 'success' : 'danger',
          'bottom'
        );
        if (this.hasilX?.error == 0) {
          this.api.dismissData('', 'confirm');
        }
      },
      (error) => {
        this.load = false;
        this.api.errorCond(error);
      }
    );
  }

  submit() {
    if (this.load) {
      return;
    }

    const leadIds = this.getLeadIds();
    if (!leadIds.length) {
      this.util.showToast('Lead ID tidak ditemukan', 'danger', 'bottom');
      return;
    }

    if (this.showFormKonfigurasi) {
      if (!this.validateFormKonfigurasi()) {
        return;
      }

      const param = {
        new_group: true,
        group_name: String(this.newKelompok.nama).trim(),
        sales_id: this.newKelompok.sales_id,
        biling_day: String(this.newKelompok.biling_day).trim(),
        subdistricts_id: String(this.newKelompok.subdistricts_id || '').trim(),
        address: String(this.newKelompok.alamat).trim(),
        rt: String(this.newKelompok.rt || '').trim(),
        rw: String(this.newKelompok.rw || '').trim(),
        groups: leadIds,
        groups_leader: this.newKelompok.is_groups_leader,
        teams: [
          {
            name: 'Regu 1',
            seq: 1,
            leader: this.newKelompok.is_teams_leader,
            members: leadIds,
          },
        ],
      };

      this.submitRequest(param);
      return;
    }

    if (this.showFormTambahRegu) {
      if (!this.hasSelectedGroup) {
        this.util.showToast('Nama Kelompok Baru wajib diisi', 'danger', 'bottom');
        return;
      }
      if (this.loadRegu) {
        this.util.showToast('Sedang memuat daftar regu...', 'warning', 'bottom');
        return;
      }
      if (!this.tambahReguLeader) {
        this.util.showToast('Ketua Regu Baru wajib diisi', 'danger', 'bottom');
        return;
      }

      const surveyorId = this.getSurveyorId();
      if (!surveyorId) {
        this.util.showToast('Surveyor tidak ditemukan', 'danger', 'bottom');
        return;
      }

      this.computeNextRegu();
      const url = `backoffice/delegasi/regu/team/${this.group}/${surveyorId}`;
      this.submitReguRequest('post', url, {
        name: this.nextReguName,
        leader: this.tambahReguLeader,
        members: leadIds,
      });
      return;
    }

    if (!this.group) {
      this.util.showToast('Nama Kelompok Baru wajib diisi', 'danger', 'bottom');
      return;
    }
    if (!this.regu) {
      this.util.showToast('Regu wajib diisi', 'danger', 'bottom');
      return;
    }

    const surveyorId = this.getSurveyorId();
    if (!surveyorId) {
      this.util.showToast('Surveyor tidak ditemukan', 'danger', 'bottom');
      return;
    }

    const url = `backoffice/delegasi/regu/team/${this.group}/${surveyorId}/${this.regu}`;
    this.submitReguRequest('put', url, {
      members: leadIds,
    });
  }

  batal() {
    this.api.dismiss();
  }
}
